<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-10-18 09:35:42
 * @LastEditTime : 2026-01-13 16:26:30
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\components\shareInfo.vue
-->
<template>
    <el-dialog :visible="visible" :title="`编辑共享合同编码`" width="980px" @close="onClose" @open="onOpen">
        <el-button class="bottom_all" type="primary" style="margin-bottom:10px" @click="addItem">添加</el-button>
        <el-table v-loading="loadingB" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
            border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
            <el-table-column label="主体公司">
                <template slot-scope="scope">
                    <el-select ref="companyName" v-model="scope.row.companyId" placeholder="请选择" @change="$nextTick(() => {
                        scope.row.companyName = this.$refs['companyName'].selected.label
                    })">
                        <el-option v-for="item in roadWorkList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="合同编码">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.shareContractCode"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="shareProductCode" label="项目编码">
                <template slot-scope="scope">
                    <span style="cursor: pointer; color: #00b85c" class="financialCode"
                        @click="changeProjectDig(scope.$index)">{{
                            scope.row.shareProductCode || "请填写" }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="shareContractName" label="合同名称">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.shareContractName"></el-input>
                </template>
            </el-table-column>
            <el-table-column  label="操作" width="70">
                <template slot-scope="scope">
                    <el-link :underline="false" type="danger" @click="deletelist(scope.$index)">
                    删除
                  </el-link>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
            <el-button class="bottom_all" type="primary" @click="onConfirm">确 定</el-button>
        </span>
        <!--  共享项目 -->
        <projectDetail ref="projectDetail" :dialog.sync="projectDetailDialog" :detailRow="config" saveType="2"
            :isCustomer="true" @reset="resetProject" @setCenterDetail="setDetailProject" />
    </el-dialog>
</template>

<script>
import { saveShareProject, queryShareProjectList } from "@/api/internetSales/performanceRecord.js"
import { getOrganizationBytypes } from "@/api/internetSales/chanceManagement";
import projectDetail from "@/views/ShareSystem/components/contract/projectDetail";
export default {
    name: "shareInfo",
    data() {
        return {
            shareForm: {},
            accessToken: "",
            roadWorkList: [],//主体公司
            projectDetailDialog: false,
            tableData: [],
            lowIndex: 0,
            low: {},
            loadingB: false,
        };
    },
    components: {
        projectDetail
    },
    props: {
        config: {
            type: Object,
            default: () => ({}),
        },
        // 控制dialog显示
        visible: {
            type: Boolean,
        },
    },
    watch: {},
    async created() {
        await getOrganizationBytypes({ typeId: "19da56b9e85648059e3cf1e7da497da4,110572600018735104" }).then(res => {
            if (res.code === 1001) {
                this.roadWorkList = res.data;
            }
        });
    },
    // 方法集合
    methods: {
        deletelist(index) {
            this.tableData.splice(index, 1)
    },
        addItem() {
            this.tableData.push({
                companyName: "",//主体id
                companyId: "",
                shareProductCode: "",//共享项目编码
                shareProductName: "",
                shareContractCode: ""//共享合同编码
            })
        },
        changeProjectDig(index) {
            this.lowIndex = index
            this.projectDetailDialog = true
        },
        setDetailProject(param) {
            this.tableData[this.lowIndex].shareProductCode = param.shareProductCode
            this.tableData[this.lowIndex].shareProductName = param.shareProductName
        },
        resetProject() {
            this.projectDetailDialog = false
        },
        async onConfirm() {
            let params = {
                engineeringId: this.config.engineeringId,
                shareEngineeringList: this.tableData
            }
            console.log(params)
            params.shareEngineeringList.forEach(item => {
                item.shareContractCode = item.shareContractCode?.replace(/\s+/g, ""); // 去空格
            });
            const res = await saveShareProject(params);
            res && res.code === 1001 ? this.$message.success("修改成功") : this.$message.error("修改失败")
            this.$emit("updated", false);
            this.$emit('update:visible', false);
        },
        onClose() {
            this.$emit('update:visible', false);
        },
        onOpen() {
            this.shareForm = this.config
            queryShareProjectList({ engineeringId: this.config.engineeringId }).then(res => {
                if (res.code == 1001) {
                    this.tableData = res.data
                }
            })
        },
    },
};
</script>
<style lang="scss" scoped></style>
